import React from "react";
import Input from "../../../UI/Input";
import usePasswordToggle from "../../../Global/Hooks/togglePassword";
import usePasswordValidation from "../../../Global/Hooks/passwordValidation";
import Button from "../../../UI/Button";
import "./index.scss";
import useUpdatePasswordApi from "../../../Global/Api/Settings/updatePasswordApi";

export default function Security() {
  const passwordToggle = usePasswordToggle();
  const passwordConfirmToggle = usePasswordToggle();
  const passwordOldToggle = usePasswordToggle();
  const passwordValidation = usePasswordValidation();
  const passwordConfirmValidation = usePasswordValidation();
  const passwordOldValidation = usePasswordValidation();
  const isButtonDisabled = !(
    passwordOldValidation?.isValid &&
    passwordValidation?.isValid &&
    passwordConfirmValidation?.isValid &&
    passwordValidation.value === passwordConfirmValidation.value
  );

  const updatePasswordApi = useUpdatePasswordApi();

  const handlePasswordChange = (event) => {
    passwordValidation.handleChange(event);
  };

  const handlePasswordConfirmChange = (event) => {
    passwordConfirmValidation.handleChange(event);
  };

  const handlePasswordOldChange = (event) => {
    passwordOldValidation.handleChange(event);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    updatePasswordApi.send({
      current_password: passwordOldValidation?.value,
      new_password: passwordValidation?.value,
      new_password_confirmation: passwordConfirmValidation?.value,
    });
  };

  return (
    <div className="security">
      <p className="security__title">Security</p>
      <form onSubmit={handleSubmit}>
        <div className="security__input">
          <Input
            id="password_old"
            label="Old password"
            placeholder="Enter password"
            type={passwordOldToggle.type}
            toggleType={passwordOldToggle.toggleType}
            icon={passwordOldToggle.icon}
            handleChange={handlePasswordOldChange}
          />
        </div>
        <div className="security__inputs">
          <div className="security__input">
            <Input
              id="password"
              label="New password"
              placeholder="Enter password"
              type={passwordToggle.type}
              toggleType={passwordToggle.toggleType}
              icon={passwordToggle.icon}
              handleChange={handlePasswordChange}
            />
          </div>
          <div className="security__input">
            <Input
              id="password_confirm"
              label="Confirm new password"
              placeholder="Enter password"
              type={passwordConfirmToggle.type}
              toggleType={passwordConfirmToggle.toggleType}
              icon={passwordConfirmToggle.icon}
              handleChange={handlePasswordConfirmChange}
            />
          </div>
        </div>
        <div className="security__btn">
          <Button text="Update password" disabled={isButtonDisabled} />
        </div>
      </form>
    </div>
  );
}
